import React, { useEffect, useRef } from 'react';
import { observer, inject } from 'mobx-react';

import { INPUT_PLACEHOLDER } from '@/utils/constants';
import { getChildInject, getTrans } from '@/utils/instantLoaded/tools';
import { FirstInitStore } from '@/stores/firstInit';
import sendImage from '@/assets/img/ic_general_send_primary@2x.png';
import sendImageNew from '@/assets/img/ic_general_send_white@3x.png';

import './style.scss';
import { isShortCutNewUI } from '@/utils/experiment/getShortCutUIUXExperiment';

const PREFIX = 'input-area-container';

type Props = {
  firstInit: FirstInitStore
}

const InputArea = (props: Props) => {
  const { firstInit, firstInit: { inputStore }} = props;
  const { userInput, isInputFocus } = inputStore;
  const isInputNewUI = isShortCutNewUI();

  const domRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    firstInit.UPDATE_INPUT_DOM_REF(domRef);
    domRef && domRef?.current?.addEventListener('focus', firstFocusHandler, false);

    return () => {
      domRef && domRef?.current?.removeEventListener('focus', firstFocusHandler, false);
    };
  }, []);

  const firstFocusHandler = () => {
    firstInit.UPDATE_INPUT_FOCUS(true);
  };

  const inputProps = {
    className: `user-input ${isInputNewUI ? 'user-input_new_ui' : ''}`,
    placeholder: getTrans(INPUT_PLACEHOLDER),
    type: 'text',
    value: userInput,
    onChange: firstInit.HANDLE_INPUT_CHANGE.bind(firstInit),
    ref: domRef,
    enterkeyhint: 'send',
    autoCorrect: 'off',
  };

  const commitBtnProps = { className: `submit-btn${userInput.length ? '' : ' disabled'} ${isInputFocus ? '' : 'not-input-focus'} ${isInputNewUI ? 'submit-btn_new_ui' : ''}` };

  return (
    <>
      {
        isInputNewUI ? (
          <div className={`${PREFIX} ${PREFIX}_new_ui`}>
            <div className="input-area-container_wrapper">
              <input {...inputProps} />
              <div {...commitBtnProps}>
                <img className="img_new_ui" src={sendImageNew} />
              </div>
            </div>
          </div>
        ) : (
          <div className={PREFIX}>
            <input {...inputProps} />
            <div {...commitBtnProps}>
              <img src={sendImage} />
            </div>
          </div>
        )
      }
    </>
  );
};

export default inject(getChildInject('firstInit'))(observer(InputArea as React.FC<{}>));
